import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-eraser",
  "use": "icon-eraser-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-eraser\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M14.81,13.93l2.34-2.34L12.94,7.37,10.6,9.71Zm-1.1,3h4.64v1.32H9.74l-4.3-4.3a.68.68,0,0,1,0-.94l7-7a.64.64,0,0,1,.93,0l5.16,5.15a.68.68,0,0,1,0,.94Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol